import { nanoid } from "nanoid"
export const createAutoMsg = (avatar, delProp) => ({
    id: nanoid(6),
    blockid: "",
    // type: ELECTRIC_AI,
    paintType: "",
    msg: "loading",
    questions: {},
    recommend: [],
    title: "",
    table: [],
    base64: [],
    filename: [],
    avatar: avatar,
    controller: new AbortController(),
    parts: [],  // 循环展示的部分
    delProp,
    isDone: 0,
    isSlow: false,
    paperCollect: false,
    graphCollect: false,
    collectType: "",
    isEditTestTitle: false,
    isCollapse: true,
    collectFormVisible: false,
    roughPaperShow: false,
    kgId: "",
    level: "",
    isLoading: false,
    isPaperDownloading: false,
    isAnswerDownloadind: false,
    startTime: Date.now(),   // 新增：记录消息创建时间（毫秒时间戳）
})